const prefix = <const T extends string>(id: T) => `Mortgage.${id}` as const

export const Config = {
  Users: {
    General: 'aa895cd3-ac6d-4aac-a48b-0901e10f73c1@mailslurp.biz',
    Statsig: '8b9ae7da-7b8b-4623-a6a2-ad1e7b31fcb6@mailslurp.biz',
  },
  Ids: {
    View: {
      MesaMortgage: prefix('View.MesaMortgage'),
      MortgageIndex: prefix('View.MortgageIndex'),
      BenefitsCard: prefix('View.BenefitsCard'),
      ScheduleCallForm: prefix('View.ScheduleCallForm'),
    },
    Press: {
      GetStarted: prefix('Press.GetStarted'),
      MarketplaceGetStarted: prefix('Press.MarketplaceGetStarted'),
      SwitchDetails: prefix('Press.SwitchDetails'),
      ScheduleCall: prefix('Press.ScheduleCall'),
      ScheduleCallClose: prefix('Press.ScheduleCallClose'),
      ScheduleCallSubmit: prefix('Press.ScheduleCallSubmit'),
    },
    Text: {
      TermsAndConditions: prefix('Text.TermsAndConditions'),
    },
  },
} as const
